/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { Link } from "react-router-dom";
import moment from "helpers/moment";

/* Helpers, constants, custom methods, internal libraries */
import {FormattedMessage} from "react-intl";
import { PAYMENT_ROUTE } from "../../../constants/routes";
import {useUserContext} from "../../../contexts/userContext";
import {AIRLINES} from "../../../constants/appConstants";

/* Components */
/* Styles */
import styles from "./styles.js"


const Content = ({ paymentsMethodDetails, setPaymentsMethodDetails, getCardIcon, getCardText, getExpiryDateText, paymentMethods, maxCardsAssignment }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const handleAssignCheckbox = (item) => {
    let updatedPaymentsMethod = [...paymentsMethodDetails];
    if (item === null) {
      updatedPaymentsMethod = [];
    } else if (parseInt(maxCardsAssignment) === 1) {
      updatedPaymentsMethod = [item];
    } else {
      const fopIndex = paymentsMethodDetails.findIndex(fop => fop.fopUUID === item?.fopUUID);

      if (fopIndex !== -1) {
        updatedPaymentsMethod.splice(fopIndex, 1);
      } else {
        updatedPaymentsMethod.push(item);
      }
    }
    setPaymentsMethodDetails(updatedPaymentsMethod);

  }
    const renderPaymentContent = () => {
    return(
      paymentMethods.map((item) => {
        const cardIsExpired = new Date(moment(item.expirationDate, 'MM/YYYY').toDate()).getTime() < new Date().getTime()
        const currentFopDetails = paymentsMethodDetails.find(fop => fop.fopUUID === item?.fopUUID)
        const isChecked = paymentsMethodDetails?.length && currentFopDetails
        const disableCheckbox = cardIsExpired || (paymentsMethodDetails.length >= parseInt(maxCardsAssignment) && !isChecked && parseInt(maxCardsAssignment) !== 1);
        const optionSelected = paymentsMethodDetails?.length && paymentsMethodDetails?.find(fop => fop.fopUUID === item?.fopUUID);
        // const applyBold = item.fSelected !== !!currentFopDetails

        return <div key={item?.fopUUID} className={optionSelected ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : `${classes.optionContainer} ${disableCheckbox ? classes.disabledContainer : ''}`} onClick={() => !disableCheckbox && handleAssignCheckbox(item)}>
          <div className={classes.cardContainer}>
            <div className={classes.cardIcon}>{getCardIcon(item?.vendorCode)}</div>
            <div className={classes.cardDetails}>
              <h3 className={classes.cardNumberText}>{getCardText(item?.vendorCode, item?.cardNumberMask)}</h3>
              <p className={optionSelected && classes.expiryText}>{getExpiryDateText(item?.expirationDate)}</p>
            </div>
          </div>
          <div>
            <input
              onClick={() => !disableCheckbox && handleAssignCheckbox(item)}
              className={`${disableCheckbox ? classes.inputDisabledStyle : ''}`}
              type={parseInt(maxCardsAssignment) === 1 ? "radio" : "checkbox"}
              name={item?.fopUUID}
              id={item?.fopUUID}
              checked={isChecked ? "checked" : ""}
            />
          </div>
        </div>
      })
    )
  }

  return (
    <div className={paymentMethods ? classes.modalContent : classes.modalContentNoPayments }>
      <div className={classes.scrollableContainer}>
        {
          (paymentMethods?.length === 0 || parseInt(maxCardsAssignment) === 1) &&
          <div
            className={paymentsMethodDetails?.length === 0 ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer}
            onClick={() => handleAssignCheckbox(null)}>
            <div>
              <h3>
                <FormattedMessage id={`changePaymentModal.personalPayment.title.${providerCode}`}/>
              </h3>
              <p>
                <FormattedMessage id={`changePaymentModal.personalPayment.description.${providerCode}`}/>
              </p>
            </div>
            <div>
              <input
                onChange={() => handleAssignCheckbox(null)}
                type="radio"
                name="personalCard"
                id='personalCard'
                checked={paymentsMethodDetails?.length === 0 ? "checked" : ""}
              />
            </div>
          </div>
        }
        {paymentMethods && renderPaymentContent()}
      </div>
      <div className={classes.linkContainer}>
        {
          providerCode === AIRLINES.AA ?
            <Link to={PAYMENT_ROUTE}>
              {
                providerCode === AIRLINES.AS ?
                  <FormattedMessage id="changePaymentModal.paymentLink.AS"/> :
                  <FormattedMessage id="changePaymentModal.paymentLink"/>
              }
            </Link> :
            <>
              <FormattedMessage id="changePaymentModal.addNewCard"/>
              <Link to={PAYMENT_ROUTE}>
                <FormattedMessage id="changePaymentModal.addNewCard.paymentLink"/>
              </Link>
            </>
        }
      </div>
    </div>
  )
}

export default Content;
